import { PersonDetailHeader } from './PersonDetailHeader';
import { PersonStatCards } from './PersonStatCards';
import { PersonTabs } from './PersonTabs';
import type { RouterOutputs } from '@/client/utils/trpc';

type Employee = RouterOutputs['employees']['list'][number];

interface PersonDetailProps {
  person: Employee;
  activeTab: string;
  onTabChange: (tab: string) => void;
  onEdit: () => void;
  onDelete: () => void;
}

export function PersonDetail({
  person,
  activeTab,
  onTabChange,
  onEdit,
  onDelete,
}: PersonDetailProps) {
  return (
    <>
      <PersonDetailHeader person={person} onEdit={onEdit} onDelete={onDelete} />
      <PersonStatCards person={person} />
      <PersonTabs person={person} activeTab={activeTab} onTabChange={onTabChange} />
    </>
  );
}
